export function errorHandler(error: any) {
  let message = 'Unknown Error';
  if (error instanceof Error) message = error.message;

  return window.showToast(message, 'failed', 3000);
}
